import type { FC } from "react";

import type { IconProps } from "./BaseIcon";
import { BaseIcon } from "./BaseIcon";

export const AthenaOneIcon: FC<IconProps> = ({
  preserveColor = false,
  ...props
}) => (
  <BaseIcon {...props}>
    <path
      d="M13.869 15.6s-2.077-2.4-2.121-5.053C11.704 7.895 13.692 6 13.692 6s2.077 2.4 2.12 5.053c.045 2.652-1.943 4.547-1.943 4.547Z"
      fill={preserveColor ? "#B5C428" : undefined}
    />
    <path
      d="M25.004 12.568s.22 5.348-2.563 9.01c-2.784 3.664-7.556 4.253-7.556 4.253s-.22-5.347 2.563-9.01c2.784-3.663 7.556-4.253 7.556-4.253Zm-7.777-.631c0 .716.574 1.263 1.325 1.263.752 0 1.326-.547 1.326-1.263 0-.716-.574-1.263-1.326-1.263-.75 0-1.325.547-1.325 1.263Z"
      fill={preserveColor ? "#7A9A01" : undefined}
    />
    <path
      d="M13.78 21.074v-.043c0-1.052-.176-4.252-1.944-6.568-2.165-2.779-5.832-3.242-5.832-3.242s-.177 4.084 1.944 6.905c1.546 1.98 3.8 2.821 4.993 3.116v4.421c0 .21.177.379.397.379a.387.387 0 0 0 .398-.379V21.2c.044-.042.044-.084.044-.126Z"
      fill={preserveColor ? "#B5C428" : undefined}
    />
  </BaseIcon>
);
